import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6618f7fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-picture-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "profile-name"
}
const _hoisted_4 = {
  key: 0,
  class: "grey"
}

import { computed } from 'vue'
import makeBlockie from 'ethereum-blockies-base64'

import { getProfileName } from '@/shared/utils'
import ProfileDefaultIcon from '@/assets/profile-default.png'
import Picture from '@/popup/components/shared/Picture.vue'
import { FrontendProfile } from '@/shared/models/Profile'

export type ProfilePictureSizes =
  | 'x-small'
  | 'small'
  | 'medium'
  | 'big'
  | 'large'

type Props = {
  size: ProfilePictureSizes
  withIdenticon?: boolean
  withName?: boolean
  frontendProfile?: FrontendProfile
  truncateNameLength?: number
  truncateAddressLength?: number
  imgUrl?: FrontendProfile['profilePicture']
}

type SizeDef = { identIconSize?: number; iconSize: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePicture',
  props: {
    size: { default: 'small' },
    withIdenticon: { type: Boolean, default: true },
    withName: { type: Boolean, default: false },
    frontendProfile: { default: undefined },
    truncateNameLength: { default: 10 },
    truncateAddressLength: { default: 4 },
    imgUrl: { default: undefined }
  },
  setup(__props: any) {

const props = __props

const SIZES: Record<ProfilePictureSizes, SizeDef> = {
  'x-small': {
    identIconSize: undefined,
    iconSize: 24,
  },
  small: {
    identIconSize: 16,
    iconSize: 40,
  },
  medium: {
    identIconSize: 20,
    iconSize: 56,
  },
  big: {
    identIconSize: 22,
    iconSize: 80,
  },
  large: {
    identIconSize: 24,
    iconSize: 88,
  },
}

const profilePictureUrl = computed(() => {
  if (props.imgUrl) {
    return props.imgUrl
  }
  if (props.frontendProfile?.profilePicture) {
    return props.frontendProfile.profilePicture
  }

  //blockie identicon for an eoa
  if (
    !props.frontendProfile?.verification?.data &&
    props.frontendProfile?.address
  ) {
    return makeBlockie(props.frontendProfile.address)
  }

  return ProfileDefaultIcon
})

const profileName = computed(() => {
  if (!props.frontendProfile) {
    return []
  }
  const username = getProfileName(
    props.frontendProfile,
    props.truncateNameLength,
    props.truncateAddressLength
  )
  return username.split('#')
})

const smallIdenticon = computed(() => {
  return props.withIdenticon &&
    props.frontendProfile?.verification?.data &&
    props.frontendProfile?.address
    ? makeBlockie(props.frontendProfile.address)
    : undefined
})
const sizeInfo = computed(() => {
  return props.size in SIZES ? SIZES[props.size] : SIZES['small']
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Picture, {
      class: "profile-picture",
      "data-testid": "profile-picture",
      size: sizeInfo.value.iconSize,
      "picture-url": profilePictureUrl.value
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        (smallIdenticon.value && sizeInfo.value.identIconSize)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: smallIdenticon.value,
              class: "profile-identicon",
              style: _normalizeStyle({
          width: `${sizeInfo.value.identIconSize}px`,
          height: `${sizeInfo.value.identIconSize}px`,
        }),
              "data-testid": "profile-identicon"
            }, null, 12 /* STYLE, PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["size", "picture-url"]),
    (_ctx.withName)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(profileName.value[0]) + " ", 1 /* TEXT */),
          (profileName.value.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "#" + _toDisplayString(profileName.value[1]), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})